export default "__VITE_ASSET__5d6fd0c7__"